import { render, staticRenderFns } from "./BlogTopicCreate.vue?vue&type=template&id=f1613fee&"
import script from "./BlogTopicCreate.vue?vue&type=script&lang=js&"
export * from "./BlogTopicCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports